module.exports = __webpack_public_path__ + "img/www.productreview.com.au.e5308613.png";